'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pure = require('recompose/pure');

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = require('../../SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ImageViewCompact = function ImageViewCompact(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M3 19h6v-7H3v7zm7 0h12v-7H10v7zM3 5v6h19V5H3z' })
  );
};
ImageViewCompact = (0, _pure2.default)(ImageViewCompact);
ImageViewCompact.displayName = 'ImageViewCompact';

exports.default = ImageViewCompact;


/*****************
 ** WEBPACK FOOTER
 ** ./~/material-ui/svg-icons/image/view-compact.js
 ** module id = 1687
 ** module chunks = 0
 **/